<script setup>
import MediaImage from '@components/MediaImage.vue';

defineProps({
  medias: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <ul class="profile-pictures">
    <li
      v-for="media in medias"
      :key="media.uuid"
    >
      <MediaImage
        img-class="profile-pictures__item"
        :uuid="media.uuid"
        :alt="media.alt"
        :width="56"
        :ratio="[ 1, 1 ]"
      />
    </li>
  </ul>
</template>
